<template>
	<path
		d="M2.09058 9.04685L1.39683 8.3531C1.10308 8.05935 1.10308 7.58435 1.39683 7.29373L7.4687 1.21873C7.76245 0.924976 8.23745 0.924976 8.52808 1.21873L14.6 7.2906C14.8937 7.58435 14.8937 8.05935 14.6 8.34998L13.9062 9.04373C13.6093 9.3406 13.125 9.33435 12.8343 9.03123L9.24995 5.26873V14.25C9.24995 14.6656 8.91558 15 8.49995 15H7.49995C7.08433 15 6.74995 14.6656 6.74995 14.25V5.26873L3.16245 9.03435C2.87183 9.3406 2.38745 9.34685 2.09058 9.04685Z"
		fill="#E2E2E2"
	/>
</template>
